var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		85884,
		5884
	],
	"./osmTagToNameMapping-cs.ts": [
		73018,
		3018
	],
	"./osmTagToNameMapping-de.template.ts": [
		439,
		439
	],
	"./osmTagToNameMapping-de.ts": [
		59115,
		9115
	],
	"./osmTagToNameMapping-en.ts": [
		63747,
		3747
	],
	"./osmTagToNameMapping-hu.template.ts": [
		10251,
		251
	],
	"./osmTagToNameMapping-hu.ts": [
		35903,
		5903
	],
	"./osmTagToNameMapping-it.template.ts": [
		845,
		845
	],
	"./osmTagToNameMapping-it.ts": [
		85137,
		5137
	],
	"./osmTagToNameMapping-pl.template.ts": [
		38962,
		8962
	],
	"./osmTagToNameMapping-pl.ts": [
		7280,
		7280
	],
	"./osmTagToNameMapping-sk.template.ts": [
		25444,
		5444
	],
	"./osmTagToNameMapping-sk.ts": [
		30242,
		242
	],
	"./osmTagToNameMapping-xx.template.ts": [
		38086,
		8086
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;